import React from "react";
import { Link } from "react-router-dom";

export default function StripeCancelled() {
  return (
    <div style={{ padding: 32 }}>
      <h2>Payment cancelled</h2>
      <p>No charges were made.</p>
      <Link to="/">Return to dashboard</Link>
    </div>
  );
}
